<template>
  <div>
    <MainHeader>

      <div class="lg:flex lg:items-center lg:justify-between">
        <!-- Left side -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center pr-4 sm:truncate">
            <h1
              class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9"
            >
              <span> Bulk Email Tool </span>
            </h1>
          </div>
        </div>

        <!-- Right side  -->
        <div class="mt-5 flex lg:mt-0 lg:ml-4 space-x-2">
        </div>
      </div>
      
    </MainHeader>
    
    <SearchOrders />
  
  </div>
</template>
<script>
import MainHeader from "@/components/elements/MainHeader.vue";
import SearchOrders from "./components/SearchOrders.vue";

export default {
  name: "BulkEmail",
  data() {
    return {
    };
  },
  components: {
    MainHeader,
    SearchOrders,
  },
  computed: {},
  mounted() {},
  methods: {},
  filters: {}
};
</script>
